/**
 * @generated SignedSource<<95529645570bd1b4ccd152c9321ef510>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type LockReservationFlow = "GOODS_RECEPTION" | "SWAP" | "%future added value";
export type SpaceConfiguration = "BACE_CLATTERING_STANDARD" | "BACE_SATELLITE_LARGE_EXTENDED" | "BACE_SATELLITE_LARGE_STANDARD" | "BACE_SATELLITE_MEDIUM_EXTENDED" | "BACE_SATELLITE_MEDIUM_STANDARD" | "BACE_SATELLITE_SMALL_EXTENDED" | "BACE_SATELLITE_SMALL_SLIM" | "BACE_SATELLITE_SMALL_STANDARD" | "BACE_STOREFRONT_2XL" | "BACE_STOREFRONT_L" | "BACE_STOREFRONT_M" | "BACE_STOREFRONT_S" | "BACE_STOREFRONT_XL" | "BACE_TRUCK_HUB_STANDARD" | "THALIA_RENZ_STANDARD_M" | "THALIA_RENZ_STANDARD_S" | "THALIA_RENZ_STANDARD_XS" | "THALIA_RENZ_WIDE_M" | "THALIA_RENZ_WIDE_S" | "%future added value";
export type UtilizationGrantPermission = "END_ON_OPEN" | "END_RENTAL" | "UNLOCK" | "%future added value";
export type pickupWarenannahmeQuery$variables = {
  hubName: string;
  skipOwnedReservations: boolean;
};
export type pickupWarenannahmeQuery$data = {
  readonly hubMeta: {
    readonly city: string;
    readonly hub: {
      readonly id: string;
      readonly spaces: ReadonlyArray<{
        readonly frame: string;
      }>;
      readonly status: HubStatus;
    };
    readonly id: string;
    readonly lat: number;
    readonly lng: number;
    readonly name: string;
    readonly organization: {
      readonly id: string;
    };
    readonly postalCode: string;
    readonly street: string;
  };
  readonly lockReservations?: {
    readonly nodes: ReadonlyArray<{
      readonly contentNote: string | null | undefined;
      readonly deactivatedAt: any | null | undefined;
      readonly deliveredAt: any | null | undefined;
      readonly flow: LockReservationFlow;
      readonly id: string;
      readonly note: string | null | undefined;
      readonly space: {
        readonly configuration: SpaceConfiguration;
        readonly dimensions: {
          readonly depthMm: number;
          readonly heightMm: number;
          readonly widthMm: number;
        };
        readonly frame: string;
        readonly hub: {
          readonly id: string;
        };
        readonly position: number;
      };
      readonly startedAt: any;
      readonly subtype: {
        readonly __typename: "B2BlockReservationSubtype";
        readonly createdByUserId: {
          readonly email: string;
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly organization: {
          readonly id: string;
          readonly name: string;
        };
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
    }>;
  };
  readonly myUtilizationGrants: {
    readonly nodes: ReadonlyArray<{
      readonly deactivatedAt: any | null | undefined;
      readonly id: string;
      readonly permissions: ReadonlyArray<UtilizationGrantPermission>;
      readonly reservation: {
        readonly contentNote: string | null | undefined;
        readonly deactivatedAt: any | null | undefined;
        readonly deliveredAt: any | null | undefined;
        readonly flow: LockReservationFlow;
        readonly id: string;
        readonly note: string | null | undefined;
        readonly space: {
          readonly configuration: SpaceConfiguration;
          readonly dimensions: {
            readonly depthMm: number;
            readonly heightMm: number;
            readonly widthMm: number;
          };
          readonly frame: string;
          readonly hub: {
            readonly id: string;
          };
          readonly position: number;
        };
        readonly startedAt: any;
        readonly subtype: {
          readonly __typename: "B2BlockReservationSubtype";
          readonly createdByUserId: {
            readonly email: string;
            readonly id: string;
            readonly name: string;
          } | null | undefined;
          readonly organization: {
            readonly id: string;
            readonly name: string;
          };
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
      };
    }>;
  };
};
export type pickupWarenannahmeQuery = {
  response: pickupWarenannahmeQuery$data;
  variables: pickupWarenannahmeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipOwnedReservations"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lng",
  "storageKey": null
},
v9 = [
  (v2/*:: as any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": (v9/*:: as any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frame",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "spaces",
      "plural": true,
      "selections": [
        (v11/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "kind": "Literal",
  "name": "pagination",
  "value": {
    "page": 0,
    "pageSize": 1000
  }
},
v14 = [
  {
    "kind": "Literal",
    "name": "input",
    "value": {}
  },
  (v13/*:: as any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deactivatedAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliveredAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentNote",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flow",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdByUserId",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v11/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "configuration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OutputDimensions",
      "kind": "LinkedField",
      "name": "dimensions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "widthMm",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "heightMm",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "depthMm",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Hub",
      "kind": "LinkedField",
      "name": "hub",
      "plural": false,
      "selections": (v9/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = [
  (v2/*:: as any*/),
  (v17/*:: as any*/),
  (v18/*:: as any*/),
  (v15/*:: as any*/),
  (v19/*:: as any*/),
  (v20/*:: as any*/),
  (v21/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subtype",
    "plural": false,
    "selections": [
      (v22/*:: as any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v23/*:: as any*/),
          {
            "kind": "CatchField",
            "field": (v24/*:: as any*/),
            "to": "NULL"
          }
        ],
        "type": "B2BlockReservationSubtype",
        "abstractKey": null
      }
    ],
    "storageKey": null
  },
  (v25/*:: as any*/)
],
v27 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "active": true,
      "flow": "GOODS_RECEPTION",
      "subtype": "B2B"
    }
  },
  (v13/*:: as any*/)
],
v28 = [
  (v2/*:: as any*/),
  (v17/*:: as any*/),
  (v18/*:: as any*/),
  (v15/*:: as any*/),
  (v19/*:: as any*/),
  (v20/*:: as any*/),
  (v21/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subtype",
    "plural": false,
    "selections": [
      (v22/*:: as any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v23/*:: as any*/),
          (v24/*:: as any*/)
        ],
        "type": "B2BlockReservationSubtype",
        "abstractKey": null
      }
    ],
    "storageKey": null
  },
  (v25/*:: as any*/)
],
v29 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v30 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v31 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Float"
},
v32 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Organization"
},
v33 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "String"
},
v34 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "DateTime"
},
v35 = {
  "enumValues": [
    "SWAP",
    "GOODS_RECEPTION"
  ],
  "nullable": false,
  "plural": false,
  "type": "LockReservationFlow"
},
v36 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Space"
},
v37 = {
  "enumValues": [
    "BACE_STOREFRONT_S",
    "BACE_STOREFRONT_M",
    "BACE_STOREFRONT_L",
    "BACE_STOREFRONT_XL",
    "BACE_STOREFRONT_2XL",
    "BACE_SATELLITE_SMALL_STANDARD",
    "BACE_SATELLITE_SMALL_SLIM",
    "BACE_SATELLITE_SMALL_EXTENDED",
    "BACE_SATELLITE_MEDIUM_STANDARD",
    "BACE_SATELLITE_MEDIUM_EXTENDED",
    "BACE_SATELLITE_LARGE_STANDARD",
    "BACE_SATELLITE_LARGE_EXTENDED",
    "BACE_CLATTERING_STANDARD",
    "BACE_TRUCK_HUB_STANDARD",
    "THALIA_RENZ_STANDARD_XS",
    "THALIA_RENZ_STANDARD_S",
    "THALIA_RENZ_STANDARD_M",
    "THALIA_RENZ_WIDE_S",
    "THALIA_RENZ_WIDE_M"
  ],
  "nullable": false,
  "plural": false,
  "type": "SpaceConfiguration"
},
v38 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "OutputDimensions"
},
v39 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v40 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Hub"
},
v41 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "DateTime"
},
v42 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "LockReservationSubtype"
},
v43 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "User"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pickupWarenannahmeQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            (v5/*:: as any*/),
            (v6/*:: as any*/),
            (v7/*:: as any*/),
            (v8/*:: as any*/),
            (v10/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v12/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "alias": null,
        "args": (v14/*:: as any*/),
        "concreteType": "UtilizationGrantPage",
        "kind": "LinkedField",
        "name": "myUtilizationGrants",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UtilizationGrant",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "reservation",
                "plural": false,
                "selections": (v26/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "myUtilizationGrants(input:{},pagination:{\"page\":0,\"pageSize\":1000})"
      },
      {
        "condition": "skipOwnedReservations",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v27/*:: as any*/),
            "concreteType": "LockReservationPage",
            "kind": "LinkedField",
            "name": "lockReservations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v26/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": "lockReservations(filter:{\"active\":true,\"flow\":\"GOODS_RECEPTION\",\"subtype\":\"B2B\"},pagination:{\"page\":0,\"pageSize\":1000})"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "pickupWarenannahmeQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v10/*:: as any*/),
          (v12/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v14/*:: as any*/),
        "concreteType": "UtilizationGrantPage",
        "kind": "LinkedField",
        "name": "myUtilizationGrants",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UtilizationGrant",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "reservation",
                "plural": false,
                "selections": (v28/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "myUtilizationGrants(input:{},pagination:{\"page\":0,\"pageSize\":1000})"
      },
      {
        "condition": "skipOwnedReservations",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v27/*:: as any*/),
            "concreteType": "LockReservationPage",
            "kind": "LinkedField",
            "name": "lockReservations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v28/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": "lockReservations(filter:{\"active\":true,\"flow\":\"GOODS_RECEPTION\",\"subtype\":\"B2B\"},pagination:{\"page\":0,\"pageSize\":1000})"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1c00712acae40e8f33b0c6c60578fdd7",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.city": (v29/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v30/*:: as any*/),
        "hubMeta.hub.spaces": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "Space"
        },
        "hubMeta.hub.spaces.frame": (v29/*:: as any*/),
        "hubMeta.hub.status": {
          "enumValues": [
            "ONLINE",
            "OFFLINE"
          ],
          "nullable": false,
          "plural": false,
          "type": "HubStatus"
        },
        "hubMeta.id": (v30/*:: as any*/),
        "hubMeta.lat": (v31/*:: as any*/),
        "hubMeta.lng": (v31/*:: as any*/),
        "hubMeta.name": (v29/*:: as any*/),
        "hubMeta.organization": (v32/*:: as any*/),
        "hubMeta.organization.id": (v30/*:: as any*/),
        "hubMeta.postalCode": (v29/*:: as any*/),
        "hubMeta.street": (v29/*:: as any*/),
        "lockReservations": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservationPage"
        },
        "lockReservations.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "LockReservation"
        },
        "lockReservations.nodes.contentNote": (v33/*:: as any*/),
        "lockReservations.nodes.deactivatedAt": (v34/*:: as any*/),
        "lockReservations.nodes.deliveredAt": (v34/*:: as any*/),
        "lockReservations.nodes.flow": (v35/*:: as any*/),
        "lockReservations.nodes.id": (v30/*:: as any*/),
        "lockReservations.nodes.note": (v33/*:: as any*/),
        "lockReservations.nodes.space": (v36/*:: as any*/),
        "lockReservations.nodes.space.configuration": (v37/*:: as any*/),
        "lockReservations.nodes.space.dimensions": (v38/*:: as any*/),
        "lockReservations.nodes.space.dimensions.depthMm": (v39/*:: as any*/),
        "lockReservations.nodes.space.dimensions.heightMm": (v39/*:: as any*/),
        "lockReservations.nodes.space.dimensions.widthMm": (v39/*:: as any*/),
        "lockReservations.nodes.space.frame": (v29/*:: as any*/),
        "lockReservations.nodes.space.hub": (v40/*:: as any*/),
        "lockReservations.nodes.space.hub.id": (v30/*:: as any*/),
        "lockReservations.nodes.space.position": (v39/*:: as any*/),
        "lockReservations.nodes.startedAt": (v41/*:: as any*/),
        "lockReservations.nodes.subtype": (v42/*:: as any*/),
        "lockReservations.nodes.subtype.__typename": (v29/*:: as any*/),
        "lockReservations.nodes.subtype.createdByUserId": (v43/*:: as any*/),
        "lockReservations.nodes.subtype.createdByUserId.email": (v29/*:: as any*/),
        "lockReservations.nodes.subtype.createdByUserId.id": (v30/*:: as any*/),
        "lockReservations.nodes.subtype.createdByUserId.name": (v29/*:: as any*/),
        "lockReservations.nodes.subtype.organization": (v32/*:: as any*/),
        "lockReservations.nodes.subtype.organization.id": (v30/*:: as any*/),
        "lockReservations.nodes.subtype.organization.name": (v29/*:: as any*/),
        "myUtilizationGrants": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "UtilizationGrantPage"
        },
        "myUtilizationGrants.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrant"
        },
        "myUtilizationGrants.nodes.deactivatedAt": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.permissions": {
          "enumValues": [
            "END_RENTAL",
            "UNLOCK",
            "END_ON_OPEN"
          ],
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrantPermission"
        },
        "myUtilizationGrants.nodes.reservation": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservation"
        },
        "myUtilizationGrants.nodes.reservation.contentNote": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedAt": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deliveredAt": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.flow": (v35/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.note": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space": (v36/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.configuration": (v37/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.dimensions": (v38/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.dimensions.depthMm": (v39/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.dimensions.heightMm": (v39/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.dimensions.widthMm": (v39/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.frame": (v29/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub": (v40/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.position": (v39/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.startedAt": (v41/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype": (v42/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.__typename": (v29/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId": (v43/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId.email": (v29/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId.name": (v29/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.organization": (v32/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.organization.id": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.organization.name": (v29/*:: as any*/)
      }
    },
    "name": "pickupWarenannahmeQuery",
    "operationKind": "query",
    "text": "query pickupWarenannahmeQuery(\n  $hubName: String!\n  $skipOwnedReservations: Boolean!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    street\n    city\n    postalCode\n    lat\n    lng\n    organization {\n      id\n    }\n    hub {\n      id\n      status\n      spaces {\n        frame\n      }\n    }\n  }\n  myUtilizationGrants(input: {}, pagination: {page: 0, pageSize: 1000}) {\n    nodes {\n      id\n      deactivatedAt\n      permissions\n      reservation {\n        id\n        startedAt\n        deliveredAt\n        deactivatedAt\n        contentNote\n        note\n        flow\n        subtype {\n          __typename\n          ... on B2BlockReservationSubtype {\n            organization {\n              id\n              name\n            }\n            createdByUserId {\n              id\n              name\n              email\n            }\n          }\n        }\n        space {\n          frame\n          position\n          configuration\n          dimensions {\n            widthMm\n            heightMm\n            depthMm\n          }\n          hub {\n            id\n          }\n        }\n      }\n    }\n  }\n  lockReservations(filter: {subtype: B2B, flow: GOODS_RECEPTION, active: true}, pagination: {page: 0, pageSize: 1000}) @skip(if: $skipOwnedReservations) {\n    nodes {\n      id\n      startedAt\n      deliveredAt\n      deactivatedAt\n      contentNote\n      note\n      flow\n      subtype {\n        __typename\n        ... on B2BlockReservationSubtype {\n          organization {\n            id\n            name\n          }\n          createdByUserId {\n            id\n            name\n            email\n          }\n        }\n      }\n      space {\n        frame\n        position\n        configuration\n        dimensions {\n          widthMm\n          heightMm\n          depthMm\n        }\n        hub {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5bbb90197b33b832fe2cbf5acc401865";

export default node;
